<template>
    <article class="group">
        <a
            :href="post.url"
            class="block"
        >
            <div class="rounded-3xl overflow-hidden bg-stone-100 aspect-4/3">
                <Image
                    :src="post.getCardImageUrl()"
                    :alt="post.title"
                    class="w-full h-full object-cover transition duration-300 group-hover:scale-[1.02]"
                />
            </div>

            <div class="mt-5 space-y-3">
                <h3
                    class="text-2xl font-semibold tracking-tight text-gray-900 group-hover:underline"
                >
                    {{ post.title }}
                </h3>
                <p class="text-base leading-7 text-gray-600">
                    {{ post.excerpt }}
                </p>
                <p class="text-sm font-medium text-gray-900">
                    Read post
                    <span aria-hidden="true">→</span>
                </p>
            </div>
        </a>
    </article>
</template>

<script setup lang="ts">
    import CMSArticle from '@/CMS/Content/Entity/CMSArticle'
    import Image from '@/Shared/Component/Image.vue'

    interface BlogPostCardProps {
        post: CMSArticle
    }

    defineProps<BlogPostCardProps>()
</script>
